import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { LiveCommunityCardsContainer } from './liveCommunityCardsContainer';
import { RabbitCommunityCardsContainer } from './rabbitCommunityCardsContainer';
export const CommunityCardsContainer = ({ bounds, allCardRenderProperties }) => {
    const { x, y } = bounds;
    return (_jsxs(_Fragment, { children: [_jsx(RabbitCommunityCardsContainer, { x: x, y: y, allCardRenderProperties: allCardRenderProperties }), _jsx(LiveCommunityCardsContainer, { x: x, y: y, allCardRenderProperties: allCardRenderProperties })] }));
};
